
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developers/api/status",
      function () {
        return require("private-next-pages/developers/api/status.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developers/api/status"])
      });
    }
  